import { Dispatch, SetStateAction } from 'react';
import { Audio } from 'types/audio';
import { useAppDispatch } from 'app/store';
import { updateSCVersionAudioDetailsEffect } from 'app/store/Releases/effects';

export const useUpdateAudioDetails = (
  setPrimaryAudio: Dispatch<SetStateAction<Audio | null>>,
  primaryAudio: Audio | null
) => {
  const dispatch = useAppDispatch();

  const updateAudioDetails = async (isrc: string) => {
    try {
      if (!primaryAudio) {
        return;
      }

      await dispatch(
        updateSCVersionAudioDetailsEffect({
          isrc,
          audioGuid: primaryAudio.guid,
        })
      ).unwrap();
      setPrimaryAudio({ ...primaryAudio, isrc });
    } catch (e) {
      // proceed
    }
  };

  return { updateAudioDetails };
};
